import { render } from "./reportbin.vue?vue&type=template&id=09a04c38&scoped=true"
import script from "./reportbin.vue?vue&type=script&lang=js"
export * from "./reportbin.vue?vue&type=script&lang=js"

import "./reportbin.vue?vue&type=style&index=0&id=09a04c38&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a04c38"]])

export default __exports__